export const FETCH_MIPS = "[ADMIN] FETCH_MIPS";
export const FETCH_MIPS_FILTER = "[ADMIN] FETCH_MIPS_FILTER";
export const FETCH_MIPS_START = "[ADMIN] FETCH_MIPS_START";
export const FETCH_MIPS_SUCCESS = "[ADMIN] FETCH_MIPS_SUCCESS";
export const FETCH_MIPS_ERROR = "[ADMIN] FETCH_MIPS_ERROR";

export const SET_MIPS_PAGINATION = "[ADMIN] SET_MIPS_PAGINATION";
export const ADD_MIP = "[ADMIN] ADD_MIP";
export const ADD_MIP_SUCCESS = "[ADMIN] ADD_MIP_SUCCESS";
export const ADD_MIP_ERROR = "[ADMIN] ADD_MIP_ERROR";

export const UPDATE_MIP = "[ADMIN]  UPDATE_MIP";
export const UPDATE_MIP_SUCCESS = "[ADMIN]  UPDATE_MIP_SUCCESS";
export const UPDATE_MIP_ERROR = "[ADMIN]  UPDATE_MIP_ERROR";

export const FETCH_ALL_MIP_MACHINES = "[ADMIN] FETCH_ALL_MIP_MACHINES";
export const FETCH_ALL_MIP_MACHINES_SUCCESS = "[ADMIN] FETCH_ALL_MIP_MACHINES_SUCCESS";
export const FETCH_ALL_MIP_MACHINES_ERROR = "[ADMIN] FETCH_ALL_MIP_MACHINES_ERROR";

export const ADD_UPDATE_MIP_MACHINE = "[ADMIN] ADD_UPDATE_MIP_MACHINE";
export const ADD_UPDATE_MIP_MACHINE_SUCCESS = "[ADMIN] ADD_UPDATE_MIP_MACHINE_SUCCESS";
export const ADD_UPDATE_MIP_MACHINE_ERROR = "[ADMIN] ADD_UPDATE_MIP_MACHINE_ERROR";

export const DELETE_MIP_MACHINE = "[ADMIN] DELETE_MIP_MACHINE";
export const DELETE_MIP_MACHINE_SUCCESS = "[ADMIN] DELETE_MIP_MACHINE_SUCCESS";
export const DELETE_MIP_MACHINE_ERROR = "[ADMIN] DELETE_MIP_MACHINE_ERROR";

export const RESET_MIP_MACHINES = "[ADMIN] RESET_MIP_MACHINES";

export const fetchMip = (payload) => {
    return {
        type: FETCH_MIPS,
        payload
    };
};

export const fetchMipFilter = (payload) => {
    return {
        type: FETCH_MIPS_FILTER,
        payload
    };
};

export const fetchMipSuccess = (mips) => {
    return {
        type: FETCH_MIPS_SUCCESS,
        mips: mips
    };
};

export const fetchMipError = (error) => {
    return {
        type: FETCH_MIPS_ERROR,
        error: error
    };
};

export const addNewMip = (mip) => {
    return {
        type: ADD_MIP,
        mip
    };
};

export const updateMip = (mip) => {
    return {
        type: UPDATE_MIP,
        mip
    };
};

export const fetchAllMipMachines = (mipId) => {
    return {
        type: FETCH_ALL_MIP_MACHINES,
        payload: mipId
    }
}

export const addUpdateMipMachine = (machine) => {
    return {
        type: ADD_UPDATE_MIP_MACHINE,
        payload: machine
    }
}

export const deleteMipMachine = (payload) => {
    return {
        type: DELETE_MIP_MACHINE,
        payload
    }
}

export const resetMipMachines = () => {
    return {
        type: RESET_MIP_MACHINES
    }
}